import "@/App.css";
import HikariEngine from "@/pages/HikariEngine";

function App() {
  return (
    <div className="hk-app grain" data-testid="app-root">
      <HikariEngine />
    </div>
  );
}

export default App;
